import {useIntl} from 'react-intl'
import useAddressFields from './useAddressFields'
import useGlobalFields from './useGlobalFields'

export default function useContactFormFields({
    form,
    prefix = '',
    casetypeOptions,
    producttypeOptions
}) {
    const {formatMessage} = useIntl()
    const {
        control,
        formState: {errors},
        getValues
    } = form

    const {firstName, lastName, phone, email} = useGlobalFields({
        form,
        prefix
    })
    const {salutation, countryCode, address1, address2, city, stateCode, postalCode} =
        useAddressFields({
            form,
            prefix
        })

    const fields = {
        salutation: {
            ...salutation,
            type: 'select'
        },
        firstName: {
            ...firstName,
            inputProps: {...firstName.inputProps, variant: 'flushed'}
        },
        lastName: {
            ...lastName,
            inputProps: {...lastName.inputProps, variant: 'flushed'}
        },
        email: {
            ...email
        },
        confirmEmail: {
            name: `${prefix}confirmEmail`,
            label: formatMessage({
                defaultMessage: 'Confirm Email',
                id: 'customer_service.contactform.confirmEmail'
            }),
            placeholder: 'you@email.com',
            type: 'email',
            defaultValue: '',
            inputProps: {
                autoComplete: 'email'
            },
            rules: {
                required: formatMessage({
                    defaultMessage: 'Please enter your email address.',
                    id: 'use_login_fields.error.required_email'
                }),
                validate: (val) => {
                    if (getValues('email') !== val) {
                        return formatMessage({
                            defaultMessage: 'The two emails do not match',
                            id: 'customer_service.contactform.not_same_email'
                        })
                    }
                }
            },
            error: errors[`${prefix}confirmEmail`],
            control
        },
        phone: {
            ...phone,
            rules: {...phone.rules, required: null}
        },
        countryCode: {
            ...countryCode
        },
        address1: {
            ...address1
        },
        address2: {
            ...address2
        },
        city: {
            ...city
        },
        stateCode: {
            ...stateCode
        },
        postalCode: {
            ...postalCode
        },
        caseType: {
            name: `${prefix}caseType`,
            label: formatMessage({
                defaultMessage: 'Enquiry Type',
                id: 'customer_service.contactform.casetype'
            }),
            defaultValue: 'Questions about Warranty',
            type: 'select',
            options: casetypeOptions?.map((option) => ({
                value: option.value,
                label: option.label
            })),
            error: errors[`${prefix}caseType`],
            control
        },
        productType: {
            name: `${prefix}productType`,
            label: formatMessage({
                defaultMessage: 'Product',
                id: 'customer_service.contactform.productType'
            }),
            defaultValue: '--None--',
            type: 'select',
            options: producttypeOptions?.map((option) => ({
                value: option.value,
                label: option.label
            })),
            error: errors[`${prefix}caseType`],
            control
        },
        subject: {
            name: `${prefix}subject`,
            label: formatMessage({
                defaultMessage: 'Subject',
                id: 'customer_service.contactform.subject'
            }),
            type: 'text',
            defaultValue: '',
            inputProps: {
                autoComplete: 'off'
            },
            rules: {
                required: formatMessage({
                    defaultMessage: 'Please enter your subject.',
                    id: 'customer_service.contactform.required_subject'
                })
            },
            error: errors[`${prefix}subject`],
            control
        },
        message: {
            name: `${prefix}message`,
            label: formatMessage({
                defaultMessage: 'Message',
                id: 'customer_service.contactform.message'
            }),
            type: 'textarea',
            defaultValue: '',
            inputProps: {
                autoComplete: 'off'
            },
            rules: {
                required: formatMessage({
                    defaultMessage: 'Please enter your message.',
                    id: 'customer_service.contactform.required_message'
                })
            },
            error: errors[`${prefix}message`],
            control
        }
    }

    return fields
}
